import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
// 插件
import toast from './components/toast'
import loading from './components/loading'
import alert from './components/alert'
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'
import Validate from './plugins/validate'
import {
  Select, Option, Radio, RadioGroup, Input
} from 'element-ui';
Vue.prototype.$qs = qs
axios.defaults.baseURL = "http://app.qdsnqwhg.cn/"
//"http://app.qdsnqwhg.cn/"
axios.defaults.withCredentials = true
Vue.use(VueAxios, axios)
Vue.use(toast)
Vue.use(loading)
Vue.use(alert)
Vue.use(Validate)
Vue.use(Select);
Vue.use(Option);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Input);

router.beforeEach((to, from, next) => {

  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();

});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
